import { NavLink } from "react-router-dom";
import { Sun, ClipboardCheck, ShoppingCart, Receipt, Menu } from "lucide-react";

export default function BottomNav({ isAdmin, modules, onMore }) {
  const items = [
    { to: "/", label: "Vandaag", icon: Sun, end: true },
    { to: "/documenten", label: "Hygiëne", icon: ClipboardCheck, module: "documents" },
    { to: isAdmin ? "/bestellingen" : "/nieuwe-bestelling", label: "Bestellen", icon: ShoppingCart, module: "orders" },
    { to: "/facturen", label: "Facturen", icon: Receipt, module: "invoices" },
  ].filter((i) => !i.module || modules[i.module]);

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur border-t border-zinc-200"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="bottom-nav">
      <div className="grid" style={{ gridTemplateColumns: `repeat(${items.length + 1}, minmax(0, 1fr))` }}>
        {items.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 h-14 text-[11px] font-semibold transition-colors ${isActive ? "text-[#1B2D5C]" : "text-zinc-400"}`}
            data-testid={`bottom-nav-${it.label.toLowerCase()}`}>
            {({ isActive }) => (
              <>
                <span className={`w-9 h-6 rounded-full flex items-center justify-center transition-colors ${isActive ? "bg-[#1B2D5C]/10" : ""}`}>
                  <it.icon size={18} strokeWidth={isActive ? 2.2 : 1.8} />
                </span>
                {it.label}
              </>
            )}
          </NavLink>
        ))}
        <button type="button" onClick={onMore} className="flex flex-col items-center justify-center gap-0.5 h-14 text-[11px] font-semibold text-zinc-400" data-testid="bottom-nav-meer">
          <span className="w-9 h-6 flex items-center justify-center"><Menu size={18} strokeWidth={1.8} /></span>
          Meer
        </button>
      </div>
    </nav>
  );
}
